import Component from '@glimmer/component';

import DateInput from 'rise-ui/components/date-input.gjs';
import classMod from 'rise-ui/helpers/class-mod.js';
import or from 'rise-ui/helpers/or.js';
import eq from 'rise-ui/helpers/eq.js';

export default class DateRangeInputComponent extends Component {
  <template>
    <span class="c-date-range-input">
      <span class="c-date-range-input__from">
        <DateInput
          class={{classMod
            "c-date-range-input__from-input qa-from-date-in"
            (or @warning @fromWarning (eq @fromState "warning")) "--warning"
            (or @error @fromError (eq @fromState "error")) "--error"
            (or @valid @fromValid (eq @fromState "valid")) "--valid"
          }}
          @date={{@from}}
          @onChange={{@onFromChange}}
        />
      </span>
      <span class="c-date-range-input__to">
        <span class="c-date-range-input__to-label">to</span>
        <DateInput
          class={{classMod
            "c-date-range-input__to-input qa-to-date-in"
            (or @warning @toWarning (eq @toState "warning")) "--warning"
            (or @error @toError (eq @toState "error")) "--error"
            (or @valid @toValid (eq @toState "valid")) "--valid"
          }}
          @date={{@to}}
          @onChange={{@onToChange}}
        />
        {{yield}}
      </span>
    </span>
  </template>
}
